import React from 'react'
import { REPORT_VIEWERS, REPORT_VIEWER_MODE } from '../constants'
import { IframeReport } from './iframe-report'
import { IframeSubfolderReport } from './iframe-subfolder-report'
import { MarkdownReport } from './markdown-report'
import { PageList } from './page-list'
import { ReportPage } from './report-page'
import { ReportViewerEmptyState } from './report-viewer-empty-state'
import { ExecutiveSummaryPage } from './executive-summary-page'

export const ReportViewer = ({ mode, report, highlightBlockId, onBlockCommentClick }) => {
  if (report && report.isEmpty && !report.userHasEditPermission) {
    return <ReportViewerEmptyState report={report} />
  }

  switch (report.viewer) {
    case REPORT_VIEWERS.PAGE_LIST:
    case REPORT_VIEWERS.DEMO_PAGE_LIST:
      return <PageList report={report} mode={mode} />
    case REPORT_VIEWERS.PAGE:
    case REPORT_VIEWERS.DEMO_PAGE:
      return <ReportPage
        report={report}
        mode={mode}
        highlightBlockId={highlightBlockId}
        onBlockCommentClick={onBlockCommentClick}
      />
    case REPORT_VIEWERS.EXECUTIVE_SUMMARY_PAGE:
      return <ExecutiveSummaryPage
        report={report}
        mode={mode}
        highlightBlockId={highlightBlockId}
        onBlockCommentClick={onBlockCommentClick}
      />
    case REPORT_VIEWERS.MARKDOWN:
      return <MarkdownReport report={report} />
    case REPORT_VIEWERS.IFRAME_SUBFOLDER:
      return <IframeSubfolderReport report={report} fullHeight={mode === REPORT_VIEWER_MODE.READ} />
    default:
      return <IframeReport report={report} fullHeight={mode === REPORT_VIEWER_MODE.READ} />
  }
}
